import { datepicker } from './date-select';

const bookingBars = Array.from(document.querySelectorAll('.js-bb'));
bookingBars.forEach(element => init(element));


function init(element) {
	const typeInputs = Array.from(element.querySelectorAll('[name="type"]'));
	typeInputs.forEach(input => input.addEventListener('change', changeOptions));

	const date = element.querySelector('.js-bb-arrival');
	const dp = datepicker(element.querySelector('.js-dp'), date);

	date.addEventListener('click', () => dp.toggle());

	if (getType() == 'cottages') {
		dp.enableModeSwitcher();
	}

	function getType() {
		let e = element.querySelector('[name="type"]');
		let checkedInput = (e.options === undefined ? 'cottages' : e.options[e.selectedIndex]);

		if (!checkedInput) {
			return;
		}

		return checkedInput.value;
	}

	element.addEventListener('submit', onSubmit);

	function onSubmit(event) {
		const nights = element.querySelector('[name="nights"]');

		if (!(getType() == 'rooms' && getSelectValue(nights) >= 4)) {
			return;
		}

		element.submit();
		event.preventDefault();
	}

	/**
	 * Update the visible form fields base on the search type. Conditional UI
	 * elements have a data-type attribute which value matches one of "types".
	 * We use this as CSS selectort to toggle their display e.g [data-type="date"]
	 */
	function changeOptions(event) {
		const inputValue = event.currentTarget.value;

		const allUIElements = Array.from(element.querySelectorAll('.js-bb-item'));
		const activeUIElements = Array.from(element.querySelectorAll(`.js-bb-item[data-type="${inputValue}"]`));

		allUIElements.forEach(element => element.hidden = true);
		activeUIElements.forEach(element => element.hidden = false);

		const nightSelect = element.querySelector('[name="nights"]');
		updateOptions(nightSelect);

		updateView();
		// updateNights();
	}

	function updateView() {
		if (getType() == 'cottages') {
			dp.enableModeSwitcher();
		} else {
			dp.switchToDateView();
			dp.disableModeSwitcher();
		}
	}

	function updateNights() {
		const nightsInput = element.querySelector('[name="nights"]');
		const options = nightsInput.options;

		let newOptions = nightsInput.dataset[getType()];
		newOptions = JSON.parse(newOptions);

		// Remove existing options
		for (let i = options.length; i >= 0; i--) {
			nightsInput.remove(i);
		}

		// Add new options
		newOptions.forEach(value => {
			const option = document.createElement('option');

			option.text = value;
			option.value = value;

			nightsInput.add(option);
		});
	}

	function updateOptions(elem) {
		const options = elem.options;
		let newOptions = JSON.parse(elem.dataset[getType()]);

		// Remove existing options
		for (let i = options.length; i >= 0; i--) {
			elem.remove(i);
		}

		// Add new options
		newOptions.forEach(value => {
			const option = document.createElement('option');

			option.text = value;
			option.value = value;

			elem.add(option);
		});
	}
}

function getSelectValue(input) {
	const selectedIndex = input.selectedIndex;
	const selectedValue = input.options[selectedIndex].value;

	return selectedValue;
}

// Number picker
$('.quantity-button').on('click', function () {
	const input = $(this).parent().find('input');
	const min = input.attr('min');
	const max = input.attr('max');

  if ($(this).hasClass('quantity-add')) {
    const newVal = parseInt(input.val()) + 1;

    if (newVal <= max) {
			input.val(newVal).trigger('change');
		}
	}

	if ($(this).hasClass('quantity-remove')) {
    const newVal = parseInt(input.val()) - 1;

    if (newVal >= min) {
			input.val(newVal).trigger('change');
		}
	}

	if (input.val() == max) {
		input.siblings('.quantity-add').addClass('disabled');
	} else {
		input.siblings('.quantity-add').removeClass('disabled');
	}

	if (input.val() == min) {
		input.siblings('.quantity-remove').addClass('disabled');
	} else {
		input.siblings('.quantity-remove').removeClass('disabled');
	}
});

$('.c-booking-form__people-toggle').click(function(e) {
	e.preventDefault();

	const container = $(this).siblings('.c-booking-form__people-container');
	container.toggleClass('hidden');
});

$('html').click(function(e) {
	if(!$(e.target).closest('.c-booking-form__people-container').length > 0 && !$(e.target).hasClass('c-booking-form__people-toggle')) {
    $('.c-booking-form__people-container.fixed').addClass('hidden');
	}
});
